import { useQuery } from "@tanstack/react-query";
import { getFeatureFlags } from "../utility/httpActions/featureFlagActions";

export const useFeatureFlags = () => {
  return useQuery({
    queryKey: ["featureFlags"],
    queryFn: getFeatureFlags,
    staleTime: 5 * 60 * 1000,
  });
};

export const useFeatureFlag = (key) => {
  const { data } = useFeatureFlags();
  return data?.flags?.[key] ?? false;
};
